import React from 'react';
import * as componentStyle from './blogStickyBanner.module.scss';
import { Link } from 'gatsby';

export default function BlogStickyBanner() {
  return (
    <div className={componentStyle.stickyBannerArea} style={{ backgroundImage: "url('../../../images/sticky-banner-bg.jpg')" }}>
      <h6 className={componentStyle.stickyBannerArea__heading}>Supercharge Your Design with Intuitive UI/UX.</h6>
      <Link className={componentStyle.stickyBannerArea__link} to='/contact'>Let's Collaborate!</Link>
    </div>
  )
}
